/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFollowers.defs'
export { main as default } from './getFollowers.defs'
